"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropzonePreview = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useElementSize_1 = require("../hooks/useElementSize");
const useTranslations_1 = require("../hooks/useTranslations");
const translations_1 = require("./translations/");
const Dropzone_helpers_1 = require("./Dropzone.helpers");
const DropzonePreviewImage_1 = __importDefault(require("./components/DropzonePreviewImage"));
const DropzonePreviewActions_1 = require("./components/DropzonePreviewActions");
const SELECT_BREAKPOINT = 480;
const DropzonePreview = (props) => {
    const { file, actions, fileSize, onRemovePreview, loadingProgress, readOnly = false, renderPreviewInfo, isDeletable = true, displayFileSize = false, } = props;
    const isLoading = loadingProgress !== undefined && loadingProgress < 100;
    // Prevent delete action if isDeletable is false or readOnly is true
    const shouldRenderDeleteAction = isDeletable && !readOnly;
    const t = (0, useTranslations_1.useTranslations)(translations_1.translations);
    const ref = (0, react_1.useRef)(null);
    const size = (0, useElementSize_1.useElementSize)(ref);
    const isMobile = (size === null || size === void 0 ? void 0 : size.width) && size.width < SELECT_BREAKPOINT;
    const actionProps = {
        file,
        actions,
        readOnly,
        isLoading,
        loadingProgress,
        shouldRenderDeleteAction,
        onRemovePreview,
    };
    return (react_1.default.createElement("div", { ref: ref, className: "dropzone-preview" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)("dropzone-preview-content", { "is-mobile": isMobile }) },
            react_1.default.createElement(DropzonePreviewImage_1.default, { file: file }),
            isMobile && react_1.default.createElement(DropzonePreviewActions_1.DropzonePreviewActions, Object.assign({}, actionProps, { className: "preview-actions-mobile" })),
            react_1.default.createElement("div", { className: "dropzone-preview-description" },
                react_1.default.createElement("span", { className: "dropzone-preview-title" },
                    file.name,
                    displayFileSize && react_1.default.createElement("span", { className: "file-size" },
                        "(",
                        (0, Dropzone_helpers_1.formatBytes)(fileSize !== null && fileSize !== void 0 ? fileSize : file.size, t),
                        ")")),
                react_1.default.createElement("span", { className: "dropzone-preview-info" }, renderPreviewInfo && renderPreviewInfo(file)))),
        !isMobile && react_1.default.createElement(DropzonePreviewActions_1.DropzonePreviewActions, Object.assign({}, actionProps))));
};
exports.DropzonePreview = DropzonePreview;
exports.default = DropzonePreview;
//# sourceMappingURL=DropzonePreview.js.map